export const initialOrgConfigState = {
  adyenActivated: false,
  fastpassActivated: false,
  isSlateActive: false,
  isUsbPrinter: false,
  kioskActivated: false,
  neptingActivated: false,
  neptingCode: "",
  neptingId: "",
  openingHours: { start: "", end: "" },
  printerIp: null,
  printerPort: null,
  printingActivated: false,
  showVivaReceipt: false,
  skipExchangeActivated: false,
  vivawalletActivated: false,
  idleImageUrl: null,
  pinCode: null,
  vivaMerchantId: null,
};

export const orgConfigReducer = (state, action) => {
  switch (action.type) {
    case "SET_CONFIG": {
      return {
        ...state,
        adyenActivated: action.payload.adyenActivated ?? initialOrgConfigState.adyenActivated,
        fastpassActivated:
          action.payload.fastpassActivated ?? initialOrgConfigState.fastpassActivated,
        isSlateActive: action.payload.slate ?? initialOrgConfigState.isSlateActive,
        kioskActivated: action.payload.kioskActivated ?? initialOrgConfigState.kioskActivated,
        neptingActivated: action.payload.neptingActivated ?? initialOrgConfigState.neptingActivated,
        neptingCode: action.payload.neptingCode ?? initialOrgConfigState.neptingCode,
        neptingId: action.payload.neptingId ?? initialOrgConfigState.neptingId,
        openingHours: action.payload.openingHours ?? initialOrgConfigState.openingHours,
        printerIp: action.payload.printerIp ?? initialOrgConfigState.printerIp,
        printerPort: action.payload.printerPort ?? initialOrgConfigState.printerPort,
        isUsbPrinter: action.payload.isUsbPrinter ?? initialOrgConfigState.isUsbPrinter,
        printingActivated:
          action.payload.printingActivated ?? initialOrgConfigState.printingActivated,
        showVivaReceipt: action.payload.showVivaReceipt ?? initialOrgConfigState.showVivaReceipt,
        skipExchangeActivated:
          action.payload.skipExchangeActivated ?? initialOrgConfigState.skipExchangeActivated,
        vivawalletActivated:
          action.payload.vivawalletActivated ?? initialOrgConfigState.vivawalletActivated,
        vivaMerchantId: action.payload.vivaMerchantId ?? initialOrgConfigState.vivaMerchantId,
        idleImageUrl: action.payload.idleImageUrl ?? initialOrgConfigState.idleImageUrl,
        pinCode: action.payload.pinCode ?? initialOrgConfigState.pinCode,
      };
    }
    case "RESET_CONFIG": {
      return {
        ...initialOrgConfigState,
      };
    }
    case "UPDATE_SLATE": {
      return {
        ...state,
        isSlateActive: action.payload,
      };
    }
    case "UPDATE_VIVA_ACTIVATED": {
      return {
        ...state,
        vivawalletActivated: action.payload,
        neptingActivated: false,
        adyenActivated: false,
      };
    }
    case "UPDATE_ADYEN_ACTIVATED": {
      return {
        ...state,
        adyenActivated: action.payload,
        neptingActivated: false,
        vivawalletActivated: false,
      };
    }
    case "UPDATE_NEPTING_ACTIVATED": {
      return {
        ...state,
        neptingActivated: action.payload,
        adyenActivated: false,
        vivawalletActivated: false,
      };
    }
    case "UPDATE_SUMUP_ACTIVATED": {
      return {
        ...state,
        neptingActivated: false,
        adyenActivated: false,
        vivawalletActivated: false,
      };
    }
    case "UPDATE_FASTPASS_ACTIVATED": {
      return {
        ...state,
        fastpassActivated: action.payload,
      };
    }
    case "UPDATE_PRINTING_ACTIVATED": {
      return {
        ...state,
        printingActivated: action.payload,
      };
    }
    case "UPDATE_SKIP_EXCHANGE_ACTIVATED": {
      return {
        ...state,
        skipExchangeActivated: action.payload,
      };
    }
    case "UPDATE_PRINTER_IP": {
      return {
        ...state,
        printerIp: action.payload,
      };
    }
    case "UPDATE_PRINTER_PORT": {
      return {
        ...state,
        printerPort: action.payload,
      };
    }
    case "UPDATE_NEPTING_ID": {
      return {
        ...state,
        neptingId: action.payload,
      };
    }
    case "UPDATE_VIVA_ID": {
      return {
        ...state,
        vivaMerchantId: action.payload,
      };
    }
    case "UPDATE_NEPTING_CODE": {
      return {
        ...state,
        neptingCode: action.payload,
      };
    }
    case "UPDATE_OPENINGHOURS": {
      return {
        ...state,
        openingHours: action.payload,
      };
    }
    case "RESET_OPENINGHOURS": {
      return {
        ...state,
        openingHours: initialOrgConfigState.openingHours,
      };
    }
    case "UPDATE_KIOSK_ACTIVATED": {
      return {
        ...state,
        kioskActivated: action.payload,
      };
    }
    case "UPDATE_SHOW_VIVA_RECEIPT": {
      return {
        ...state,
        showVivaReceipt: action.payload,
      };
    }
    case "UPDATE_PRINTER_CONFIG": {
      return {
        ...state,
        printerIp: action.payload.printerIp,
        printerPort: action.payload.printerPort,
        isUsbPrinter: action.payload.isUsbPrinter,
      };
    }
    case "UPDATE_IDLE_IMAGE": {
      return {
        ...state,
        idleImageUrl: action.payload,
      };
    }
    case "UPDATE_PIN_CODE": {
      return {
        ...state,
        pinCode: action.payload,
      };
    }
    default:
      throw Error(`Unknow action : ${action.type}`);
  }
};
